export enum ButtonType {
  Default = 'default',
  Result = 'result',
}
